import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'ci-button',
  styleUrl: 'ci-button.scss',
})
export class CiButton {
  @Prop() variant: 'primary' | 'secondary' | 'text' = 'primary';
  @Prop() href?: string;
  @Prop() styles?: string;

  render() {
    if (this.href != undefined) {
      return (
        <a class={`ghf-${this.variant}-button ${this.styles != undefined ? this.styles : ''}`} href={this.href}>
          <slot name="start-icon"></slot>
          <slot></slot>
        </a>
      );
    }
    return (
      <button class={`ghf-${this.variant}-button ${this.styles != undefined ? this.styles : ''}`}>
        <slot name="start-icon"></slot>
        <slot></slot>
      </button>
    );
  }
}
